export default "__VITE_ASSET__Ms21jo$Z__"